export function fadeIn(element, time = 300, opacity = 1) {
	return element.animate(
		[
			{
				opacity: 0
			},
			{
				opacity
			}
		],
		{
			duration: time,
			fill: 'forwards',
			easing: 'ease-out'
		}
	);
}
export function fadeOut(element, time = 300, opacity = 0) {
	return element.animate(
		[
			{
				opacity: 1
			},
			{
				opacity
			}
		],
		{
			duration: time,
			fill: 'forwards',
			easing: 'ease-out'
		}
	);
}
export function fadeInDown(element, time = 500) {
	return element.animate(
		[
			{
				opacity: 0,
				transform: 'translateY( -100% )'
			},
			{
				opacity: 1,
				transform: 'translateY( 0% )'
			}
		],
		{
			duration: time,
			fill: 'forwards',
			easing: 'ease-out'
		}
	);
}

export function fadeInUp(element, time = 500) {
	return element.animate(
		[
			{
				opacity: 0,
				transform: 'translateY( 100% )'
			},
			{
				opacity: 1,
				transform: 'translateY( 0% )'
			}
		],
		{
			duration: time,
			fill: 'forwards',
			easing: 'ease-out'
		}
	);
}
export async function sequentialFade(
	elements = [],
	opacity = 0,
	duration = 300,
	delay = 100
) {
	Array.from(elements).forEach((el, index) => {
		el.animate(
			{opacity},
			{delay: index * delay, duration, fill: 'forwards'}
		);
	});
	const time = (elements.length - 2) * delay + duration;
	await new Promise((resolve) => {
		setTimeout(() => {
			resolve();
		}, time);
	});
}
export function shrinkOut(element, time = 1000, scale = 0) {
	return element.animate(
		[
			{
				transform: 'scale(1)'
			},
			{
				transform: `scale(${scale})`
			}
		],
		{
			duration: time,
			fill: 'forwards',
			easing: 'ease-in-out'
		}
	);
}
export function growIn(element, time = 1000, scale = 1) {
	return element.animate(
		[
			{
				transform: 'scale(0)'
			},
			{
				transform: `scale(${scale})`
			}
		],
		{
			duration: time,
			fill: 'forwards',
			easing: 'ease-in-out'
		}
	);
}
export function brandFontColour(element, colour = '00B2A9') {
	return element.animate(
		[
			{
				color: `#${colour}`
			}
		],
		{
			duration: 100,
			fill: 'forwards'
		}
	);
}
export function addBackgroundColour(element, colour = '00B2A9') {
	return element.animate(
		[
			{
				backgroundColor: `#${colour}`
			}
		],
		{
			duration: 100,
			fill: 'forwards'
		}
	);
}
export function colourSwipe(element, colour = '00B2A9', direction = '+') {
	return (
		element.animate(
			[
				{
					boxShadow: `inset ${direction}200vw 0 0 0 #${colour}`
				}
			],
			{
				duration: 500,
				easing: 'linear',
				pseudoElement: '::after'
			}
		) &&
		element.animate(
			[
				{
					backgroundColor: `#${colour}`
				}
			],
			{
				duration: 400,
				delay: 100,
				fill: 'forwards'
			}
		)
	);
}

const api = {
	fadeIn,
	fadeOut,
	fadeInDown,
	sequentialFade,
	shrinkOut,
	growIn,
	brandFontColour,
	addBackgroundColour,
	colourSwipe
};

export default api;
